import { render, staticRenderFns } from "./ConversationNewChat.vue?vue&type=template&id=ddf16a28&scoped=true&"
import script from "./ConversationNewChat.vue?vue&type=script&lang=js&"
export * from "./ConversationNewChat.vue?vue&type=script&lang=js&"
import style0 from "./ConversationNewChat.vue?vue&type=style&index=0&id=ddf16a28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf16a28",
  null
  
)

export default component.exports